import styled from 'styled-components';
import TestOps from './sub/TestOps';
import DataService from './sub/DataService';
import SSLO from './sub/SSLO';
import Information from './sub/Information';
import Vision from './sub/Vision';
import Benefit from './sub/Benefit';
import Recruit from './sub/Recruit';
import Management from './sub/Management';
import Ethical from './sub/Ethical';
import Social from './sub/Social';
import Environmental from './sub/Environmental';
import ContentBanner from '../../components/ContentBanner';
import { IHeaderMenu } from '../../components/Interfaces';
import Blog from './sub/Blog';
import Contact from './sub/Contact';
import Aitest from './sub/Aitest';

const Detail = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: #ffffff;
`;

const Container = styled.div`
  width: 100%;
  background-color: #ffffff;
`;

interface IDetail {
  type: string;
  data: IHeaderMenu;
  color: string;
}

const DetailPresenter: React.FC<IDetail> = ({
  type,
  data,
  color,
}) => {
  return (
    <Detail>
      <ContentBanner data={data} color={color} />
      <Container>
        {type === "testops" ?
          <TestOps />
        : type === "data" ?
          <DataService />
        : type === "sslo" ?
          <SSLO />
        : type === "information" ?
          <Information />
        : type === "vision" ?
          <Vision />
        : type === "benefit" ?
          <Benefit />
        : type === "recruit" ?
          <Recruit />
        : type === "blog" ?
          <Blog />
        : type === "management" ?
          <Management />
        : type === "ethical" ?
          <Ethical />
        : type === "social" ?
          <Social />
        : type === "environmental" ?
          <Environmental />
        : type === "contact" ?
           <Contact />
        : type === "aitest" ?
           <Aitest />
        :
          <></>
        }
      </Container>
    </Detail>
  );
};

export default DetailPresenter;